const API = process.env.REACT_APP_BACKEND_URL;

export async function affFetch(path, options = {}) {
  const doFetch = () => fetch(`${API}/api/affiliates${path}`, {
    credentials: 'include', ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  let res = await doFetch();
  if (res.status === 401 && path !== '/refresh' && path !== '/login') {
    const r = await fetch(`${API}/api/affiliates/refresh`, { method: 'POST', credentials: 'include' });
    if (r.ok) res = await doFetch();
  }
  return res;
}
